import { type JSX, Show } from 'solid-js';
import type { GetConfigurationResponse } from '@data-access/connect/tc-issue-management';
import {
  getPriorityColor,
  getPriorityTranslation,
} from '../../utils/issue-icons';

export interface IssuePriorityBadgeProps {
  priority?: string;
  configuration?: GetConfigurationResponse | null;
}

/**
 * Renders a "hollow pill" style badge for an issue priority using the
 * bookmark font icon. The color is driven by the Issue API configuration,
 * falling back to the legacy default color when unavailable.
 */
export function IssuePriorityBadge(
  props: IssuePriorityBadgeProps
): JSX.Element {
  const color = (): string =>
    getPriorityColor(props.configuration ?? null, props.priority);

  const label = (): string => getPriorityTranslation(props.priority);

  return (
    <Show when={props.priority}>
      <div class="flex items-center">
        <div class="flex items-center gap-2 py-1 rounded-sm">
          <i
            class="icon-font tc-icon-bookmark i16"
            style={{ color: color() }}
          />
          <span class="text-xs font-semibold text-gray-600">{label()}</span>
        </div>
      </div>
    </Show>
  );
}
